import ConnectorPinsSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/ConnectorPinsSection'
import DTCMappingSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import SelectConnectorSection from '../../../../../components/dtcs/TATMappings/ConnectorMapping/SelectConnectorSection'
import ConnectorPinsStore from '../../../../../components/dtcs/TATMappings/ConnectorMapping/context/context'

const TatConnectorMapping = () => {
  return (
    <ConnectorPinsStore>
      <div className="flex items-stretch flex-grow" style={{ height: '90vh' }}>
        <ConnectorPinsSection />
        <div className="flex-1 w-1/3 flex flex-col px-4 py-2 bg-tracer-darker-blue flex-grow">
          <SelectConnectorSection />
        </div>
        <DTCMappingSection />
      </div>
    </ConnectorPinsStore>
  )
}

export default TatConnectorMapping
